<template>
    <div>
        <el-divider></el-divider>
        <el-col :span="12">
            {{ $t("lang.选择日期") }}<el-date-picker style="margin-left: 20px;" v-model="searchObj.searchRange" @change="getList" type="datetimerange" :picker-options="pickerOptions" :range-separator="$t('lang.至')" :start-placeholder="$t('lang.开始日期')" :end-placeholder="$t('lang.结束日期')" align="right">
            </el-date-picker>
            <el-button type="primary" @click="exportExcel" style="margin-left: 20px;" icon="el-icon-document">{{ $t("lang.导出") }}1</el-button>
            <el-button type="primary" @click="exportExcel2" style="margin-left: 20px;" icon="el-icon-document">{{ $t("lang.导出") }}2</el-button>

            <vxe-table ref="myTable" :loading="tableLoading" :data="tableData" style="margin-top: 5px;" border :row-config="{ isCurrent: true, isHover: true }" :checkbox-config="{ labelField: 'cho' }" @current-row-change="currentRowChange" height="630">
                <vxe-column type="checkbox" width="40"></vxe-column>
                <vxe-column field="serialNumber" :title="$t('lang.序列号')" width="90"></vxe-column>
                <vxe-column field="shiYanFangFa" :title="$t('lang.试验方法')" :formatter="formatShiYanFangFa"></vxe-column>
                <vxe-column field="jianCeDuiXiang" :title="$t('lang.检测对象')" :formatter="formatJianCeDuiXiang" width="80"></vxe-column>
                <vxe-column field="shiYanLeiXing" :title="$t('lang.试验类型')" :formatter="formatShiYanLeiXing" width="80"></vxe-column>
                <vxe-column field="shiYanBianHao" :title="$t('lang.试验编号')"></vxe-column>
                <vxe-column field="startTime" width="150" :title="$t('lang.试验时间')"></vxe-column>
                <vxe-column :title="$t('lang.操作')" width="50" align="center">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="primary" icon="vxe-icon-delete" circle @click="delRow(row)"></vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <vxe-pager align="left" @page-change="getList" :page-size.sync="searchObj.pageSize" :current-page.sync="searchObj.currentPage" :total="searchObj.total" :layouts="['PrevPage', 'Jump', 'PageCount', 'NextPage', 'Total']">
            </vxe-pager></el-col>
        <el-col :span="12" style="padding-left: 5px;">
            <ZuJian_ShuiNi_KongBai v-if="detailData.main.jianCeDuiXiang == 'ShuiNi' && detailData.main.shiYanLeiXing == 'KongBai'" :detailData="detailData"></ZuJian_ShuiNi_KongBai>
            <ZuJian_ShuiNi_XiaoSuanYin v-else-if="detailData.main.jianCeDuiXiang == 'ShuiNi' && detailData.main.shiYanLeiXing == 'XiaoSuanYin'" :detailData="detailData"></ZuJian_ShuiNi_XiaoSuanYin>
            <ZuJian_ShuiNi_LvHuaWu v-else-if="detailData.main.jianCeDuiXiang == 'ShuiNi' && detailData.main.shiYanLeiXing == 'LvHuaWu'" :detailData="detailData"></ZuJian_ShuiNi_LvHuaWu>
            <ZuJian_WaiJiaJi_KongBai v-else-if="detailData.main.jianCeDuiXiang == 'WaiJiaJi' && detailData.main.shiYanLeiXing == 'KongBai'" :detailData="detailData"></ZuJian_WaiJiaJi_KongBai>
            <ZuJian_WaiJiaJi_XiaoSuanYin v-else-if="detailData.main.jianCeDuiXiang == 'WaiJiaJi' && detailData.main.shiYanLeiXing == 'XiaoSuanYin'" :detailData="detailData"></ZuJian_WaiJiaJi_XiaoSuanYin>
            <ZuJian_WaiJiaJi_LvHuaWu v-else-if="detailData.main.jianCeDuiXiang == 'WaiJiaJi' && detailData.main.shiYanLeiXing == 'LvHuaWu'" :detailData="detailData"></ZuJian_WaiJiaJi_LvHuaWu>
            <el-tabs v-model="activeName" stretch>
                <el-tab-pane :label="$t('lang.曲线1')">
                    <ZuJian_Chart ref="detail" :list_detail="detailData.detail" :main="detailData.main" :div_id="'div_llz801_chart'" :type="'detail'"></ZuJian_Chart>
                </el-tab-pane>
                <el-tab-pane :label="$t('lang.曲线2')" :disabled="detailData.main.jianCeDuiXiang !== 'WaiJiaJi'">
                    <ZuJian_Chart :list_detail="detailData.detail2" :main="detailData.main" :div_id="'div_llz801_chart2'" :type="'detail2'"></ZuJian_Chart>
                </el-tab-pane>
            </el-tabs>

        </el-col>
    </div>
</template>

<script>
import moment from "moment";
import ZuJian_ShuiNi_KongBai from "./ZuJian_ShuiNi_KongBai.vue";
import ZuJian_ShuiNi_XiaoSuanYin from "./ZuJian_ShuiNi_XiaoSuanYin.vue";
import ZuJian_ShuiNi_LvHuaWu from "./ZuJian_ShuiNi_LvHuaWu.vue";
import ZuJian_WaiJiaJi_KongBai from "./ZuJian_WaiJiaJi_KongBai.vue";
import ZuJian_WaiJiaJi_XiaoSuanYin from "./ZuJian_WaiJiaJi_XiaoSuanYin.vue";
import ZuJian_WaiJiaJi_LvHuaWu from "./ZuJian_WaiJiaJi_LvHuaWu.vue";

import ZuJian_Chart from "./ZuJian_Chart.vue";
export default {
    components: {
        ZuJian_ShuiNi_KongBai,
        ZuJian_ShuiNi_XiaoSuanYin,
        ZuJian_ShuiNi_LvHuaWu,
        ZuJian_WaiJiaJi_KongBai,
        ZuJian_WaiJiaJi_XiaoSuanYin,
        ZuJian_WaiJiaJi_LvHuaWu,
        ZuJian_Chart,
    },
    data() {
        let that = this;
        return {
            activeName: 0,
            tableLoading: false,
            tableData: [],
            searchRange: null,
            searchObj: {
                currentPage: 1,
                pageSize: 50,
                total: 0,
                searchRange: null,
            },
            detailData: { main: {}, detail: [], detail2: [] },
            // searchRange: [moment().startOf("day").add(-30, "days").toDate(), moment().startOf("day").add(1, "days").toDate()],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "1" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "2" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-1, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "3" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-2, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "7" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-6, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "15" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-14, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "30" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-29, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                ],
            },
        };
    }, methods: {
        delRow(row) {
            let that = this;
            that.$confirm(that.$t("lang.确定要删除吗")).then(function () {
                that.axios
                    .post("LLZ801_Result/DelModel", {
                        id: row.id,
                    })
                    .then(function (response) {
                        if (response.data.code == 101) {
                            that.$message({
                                type: "success",
                                message: that.$t("lang.删除成功"),
                            });
                            that.getList();
                        }
                    });
            });
        },
        currentRowChange({ newValue }) {
            let that = this;
            const loading = that.$loading({
                lock: true,
                text: that.$t("lang.加载中"),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            that.axios.post("LLZ801_Result/GetDetail", { id: newValue.id }).then((response) => {
                loading.close();
                that.detailData = response.data.data;
            });
        },
        formatShiYanFangFa({ cellValue }) {
            let that = this;
            if (cellValue == "DianWeiFa") {
                return that.$t("lang.电位法");
            }
            else if (cellValue == "DianWeiDiDingFa") {
                return that.$t("lang.电位滴定法");
            }
            else {
                return cellValue;
            }
        },
        formatJianCeDuiXiang({ cellValue }) {
            let that = this;
            if (cellValue == "ShuiNi") {
                return that.$t("lang.水泥");
            }
            else if (cellValue == "WaiJiaJi") {
                return that.$t("lang.外加剂");
            }
            else {
                return cellValue;
            }
        },
        formatShiYanLeiXing({ cellValue }) {
            let that = this;
            if (cellValue == "KongBai") {
                return that.$t("lang.空白");
            }
            else if (cellValue == "XiaoSuanYin") {
                return that.$t("lang.硝酸银");
            }
            else if (cellValue == "LvHuaWu") {
                return that.$t("lang.氯化物");
            }
            else if (cellValue == "BanHeWu") {
                return that.$t("lang.拌合物");
            }
            else if (cellValue == "ShuiHuiBi") {
                return that.$t("lang.水灰比");
            }
            else if (cellValue == "ZhiLiangTiJi") {
                return that.$t("lang.质量体积");
            }
            else {
                return cellValue;
            }
        },
        getList() {
            let that = this;
            that.tableLoading = true;
            that.axios.post("LLZ801_Result/GetList", that.searchObj).then((response) => {
                that.tableLoading = false;
                that.tableData = response.data.data.data;
                that.searchObj.total = response.data.data.total;
            });
        },
        exportExcel() {
            let that = this;
            const $table = that.$refs.myTable;
            const selectRecords = $table.getCheckboxRecords();
            if (selectRecords.length == 0) {
                that.$message({
                    type: "warning",
                    message: that.$t("lang.请至少选择一条数据"),
                });
                return;
            }
            let id1 = 0, id2 = 0;
            for (let i = 0; i < selectRecords.length; i++) {
                if (selectRecords[i].shiYanLeiXing == "KongBai") {
                    if (id1 == 0) {
                        id1 = selectRecords[i].id;
                    }
                }
                if (selectRecords[i].shiYanLeiXing == "LvHuaWu") {
                    if (id2 == 0) {
                        id2 = selectRecords[i].id;
                    }
                }
            }
            if (id1 == 0 && id2 == 0) {
                that.$message({
                    type: "warning",
                    message: that.$t("lang.请至少选择一条空白试验和一条氯化物试验数据"),
                });
                return;
            }
            const loading = that.$loading({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            that.axios
                .post("LLZ801_Result/ExportExcel", { id1: id1, id2: id2 }, {
                    responseType: "blob",
                })
                .then((response) => {
                    loading.close();
                    let b = new Blob([response.data], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                    });
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(b); // 创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = "llz801"; // 下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); // 点击下载
                    document.body.removeChild(downloadElement); // 下载完成移除元素
                    window.URL.revokeObjectURL(href); // 释放掉blob对象
                });
        },
        exportExcel2() {
            let that = this;
            const $table = that.$refs.myTable;
            const selectRecords = $table.getCheckboxRecords();
            if (selectRecords.length == 0) {
                that.$message({
                    type: "warning",
                    message: that.$t("lang.请至少选择一条数据"),
                });
                return;
            }
            let id1_1 = 0, id1_2 = 0, id2_1 = 0, id2_2 = 0;
            for (let i = 0; i < selectRecords.length; i++) {
                if (selectRecords[i].shiYanLeiXing == "KongBai") {
                    if (id1_1 == 0) {
                        id1_1 = selectRecords[i].id;
                    } else {
                        id1_2 = selectRecords[i].id;
                    }
                }
                if (selectRecords[i].shiYanLeiXing == "LvHuaWu") {
                    if (id2_1 == 0) {
                        id2_1 = selectRecords[i].id;
                    } else {
                        id2_2 = selectRecords[i].id;
                    }
                }
            }
            if (id1_1 == 0 && id1_2 == 0 && id2_1 == 0 && id2_2 == 0) {
                that.$message({
                    type: "warning",
                    message: that.$t("lang.请至少选择一条空白试验和一条氯化物试验数据"),
                });
                return;
            }
            const loading = that.$loading({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            that.axios
                .post("LLZ801_Result/ExportExcel2", {
                    id1_1: id1_1,
                    id1_2: id1_2,
                    id2_1: id2_1,
                    id2_2: id2_2
                }, {
                    responseType: "blob",
                })
                .then((response) => {
                    loading.close();
                    let b = new Blob([response.data], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                    });
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(b); // 创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = "llz801"; // 下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); // 点击下载
                    document.body.removeChild(downloadElement); // 下载完成移除元素
                    window.URL.revokeObjectURL(href); // 释放掉blob对象
                });
        },
    },

    mounted() {
        let that = this;
        that.getList();
    }

};
</script>

<style></style>